var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-4" }, [
    _c(
      "table",
      {
        staticClass: "table tablerow",
        attrs: { "aria-label": _vm.$t("Attachment.Attachments") }
      },
      [
        _c("thead", [
          _c("tr", [
            _c("th", [
              _c("span", [_vm._v(_vm._s(_vm.$t("Attachment.Attachments")))])
            ]),
            _vm._v(" "),
            _c("th", [
              _c("span", [_vm._v(_vm._s(_vm.$t("Attachment.Downloaded")))])
            ]),
            _vm._v(" "),
            _c("th", [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("Attachment.DownloadOrRemove")))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.attachments, function(attachment, index) {
            return _c(
              "tr",
              { key: index },
              [
                _c(
                  "td",
                  { staticClass: "normal" },
                  [
                    _c("plain-text-control", {
                      attrs: {
                        title: attachment.displayKey,
                        required: attachment.isRequired,
                        noMargin: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: {
                      normal: true,
                      "validation-error":
                        !_vm.uploading.includes(index) &&
                        _vm.isFileNameDuplicate(
                          attachment.fileNameWithExtension
                        )
                    }
                  },
                  [
                    _vm.uploading.includes(index)
                      ? _c("span", [
                          _c("i", [
                            _vm._v(_vm._s(_vm.$t("Attachment.Downloading")))
                          ])
                        ])
                      : _c("span", [
                          attachment.fileNameWithExtension
                            ? _c("span", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(attachment.fileNameWithExtension)
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.uploading.includes(index) &&
                                _vm.isFileNameDuplicate(
                                  attachment.fileNameWithExtension
                                )
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Validation.DuplicateAttachmentFileName"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !attachment.fileNameWithExtension
                            ? _c("i", [
                                _vm._v(_vm._s(_vm.$t("Attachment.NoFile")))
                              ])
                            : _vm._e()
                        ])
                  ]
                ),
                _vm._v(" "),
                _c("attachment-wrapper-table-cell", {
                  key: "attachment-" + index,
                  attrs: {
                    inputId: "attachment-" + index,
                    required: attachment.isRequired,
                    attachment: attachment,
                    notifyonuploadedsuccess: false,
                    classes: ["normal"],
                    showErrorText: true
                  },
                  on: {
                    "start-upload": function($event) {
                      return _vm.startUpload($event, index)
                    },
                    "stop-upload": function($event) {
                      return _vm.stopUpload($event, index)
                    },
                    "deleted-attachment": function($event) {
                      return _vm.deletedAttachment($event, attachment)
                    },
                    "added-attachment": function($event) {
                      return _vm.addedAttachment($event, attachment)
                    }
                  }
                })
              ],
              1
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }